import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfigEntityService } from "src/app/core/services/config-entity.service";
import { DeploymentService } from "../../../../core/services/deployment.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionDispatcherService } from "src/app/core/services/function-dispatcher.service";

@Component({
  selector: "app-add-new-credential",
  templateUrl: "./add-new-credential.component.html",
  styleUrls: ["./add-new-credential.component.scss"],
})  
export class AddNewCredentialComponent implements OnInit {
  cloudProviders = []
  providerForm: FormGroup;
  provider = {
    name: "AWS",
    fields: [
      { name: "accessKey", type: "text", required: true, value:"" },
      { name: "secretKey", type: "password", required: true, value: "" },
      { name: "clinetId", type: "text", required: true, value: "" },
    ],
  };

  updateProvider = {
    name: "AWS",
    fields: [
      { name: "accessKey", value: "", required: true, },
      { name: "secretKey", value: "", required: true, },
      { name: "clinetId", value: "", required: true, },
    ],
  }

  updateFriendlyName = "";
  constructor(
    private fb: FormBuilder,
    private configEntityService: ConfigEntityService,
    public dialog: MatDialogRef<AddNewCredentialComponent>,
    private depService: DeploymentService,
    private spinner: NgxSpinnerService,
    private formComm: FunctionDispatcherService,
    @Inject(MAT_DIALOG_DATA) public data: { 
      cloudValue: string, 
      cloudName: string, 
      updateForm: false, 
      friendlyName: string, 
      maxHeight: string,  
      depName: string
    }
  ) {}

  cloudProviderValue = this.data.cloudValue;
  cloudProvider = this.data.cloudName;
  isUpdateForm = this.data.updateForm;
  depName = this.data.depName;
  infraName = "";
  friendlyName = this.data.friendlyName
  maxHeight = this.data.maxHeight ? this.data.maxHeight : '80vh';
  dialogTitle = this.isUpdateForm ? "Update Credentials" : "Add New Credentials";

  ngOnInit(): void {
    this.getCloudProviderNameAndValue()
    if(this.depName != undefined && this.depName != null && this.depName != "") {
      this.dialogTitle = "Update connectors for " + this.depName;
    }
    else{
      if(this.friendlyName != undefined && this.friendlyName != null && this.friendlyName != "") {
        this.dialogTitle = "Update Credentials for " + this.friendlyName;
      }
      else{
        this.dialogTitle = "Add new credentials";
      }  
    }
    if (this.isUpdateForm) {
      this.updateInfraCred(this.friendlyName)
    } else {
      this.getInfraCredJson(this.cloudProviderValue);
    }
  }


  getCloudProviderNameAndValue() {
    this.depService.getAllCloudProvidersValueText().subscribe({
      next: (data: any) => {
        if (data) {
          this.cloudProviders = data;
        }
      },
      error: (error) => {
        //this.snackBar.open("Failed to fetch cloud provider list, please try again.", "Ok", { duration: 5000 });
      }
    })
  }

  getInfraCredJson(infra) {
    this.configEntityService.getInfraCredentialJson(infra).subscribe({
      next: async (data) => {
        this.provider = await JSON.parse(JSON.stringify(data));
        this.buildForm();
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  buildForm() {
    const group: any = {};
    this.provider.fields.forEach((field) => {
      group[field.name] = [
        field.required ? "" : null,
        field.required ? Validators.required : null,
      ];
    });
    this.providerForm = this.fb.group(group);
  }

   updateInfraCred(name) {
    this.spinner.show("addNewCredential");
    try{
      this.configEntityService.getCredForUpdate(name, this.depName).subscribe({
        next: async (data) => {
          //this.updateProvider = await JSON.parse(JSON.stringify(data));
          let result = await JSON.parse(JSON.stringify(data));
          this.updateFriendlyName = result.friendlyName;
          this.infraName = result.infrastructure
          const group: any = {};
          let creds = JSON.parse(result.credential)
          if(creds == null || creds == undefined) {
            this.dialog.close({ "res": false, "data": "Cannot get connector details" });
            return;
          }
            this.updateProvider = {
              name: result.infrastructure,
              fields: Object.keys(creds).map(key => ({
                name: key,
                value: creds[key],
                required: true
              }))
            };
            this.updateProvider.fields.forEach((field) => {
              group[field.name] = [field.value, field.required ? Validators.required : null];
            });
          this.providerForm = this.fb.group(group);
          this.spinner.hide("addNewCredential");
        },
        error: (err) => {
          this.spinner.hide("addNewCredential");
          console.error(err)
        }
      })
    }
    catch (e) {
      console.error("Error in updateInfraCred: ", e);
      this.spinner.hide("addNewCredential");
      this.dialog.close({ "res": false, "data": "Error while fetching credentials" });
      return;
    }
    
  }


  onSubmit(isUpdate) {
    if (isUpdate) {
      if (this.providerForm.valid) {
        let x = {
          Infrastructure: this.infraName,
          FriendlyName: this.providerForm.value["Friendly Name"],
          Credential: JSON.stringify(this.providerForm.value)
        }
        this.configEntityService.updateInfraCred(this.updateFriendlyName, x, this.depName).subscribe({
          next: (data) => {
            this.dialog.close({ "res": true, "data": data })
          },
          error: (err) => {
            this.dialog.close({ "res": false, "data": "Error while updating credentials" })
          }
        })
      }
    } else {
      if (this.providerForm.valid) {
        let x = {
          Infrastructure: this.cloudProviderValue.toString(),
          FriendlyName: this.providerForm.value["Friendly Name"],
          Credential: JSON.stringify(this.providerForm.value)
        }
        this.configEntityService.addNewInfraCred(x, this.cloudProvider.toString()).subscribe({
          next: (data) => {
            this.formComm.triggerFormRefresh({
              refreshForm: true,
              name: x.FriendlyName,
              action: 'credential'
            });
            this.dialog.close({ "res": true, "data": data })
          },
          error: (err) => {
            this.dialog.close({ "res": false, "data": "Error while adding new credentials" })
          }
        })
      }
    }
  }

  onClose() {
    this.dialog.close({ "res": false, "data":"" });
  }
}
